import colors from '@constants/colors'

const theme = {
  colors
}

export default theme
